import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=df20bd1c&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=df20bd1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df20bd1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df20bd1c')) {
      api.createRecord('df20bd1c', component.options)
    } else {
      api.reload('df20bd1c', component.options)
    }
    module.hot.accept("./MessageCenter.vue?vue&type=template&id=df20bd1c&scoped=true", function () {
      api.rerender('df20bd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MessageCenter.vue"
export default component.exports